import { render, staticRenderFns } from "./GiftPurchaseImportForm.vue?vue&type=template&id=12963794&"
import script from "./GiftPurchaseImportForm.vue?vue&type=script&lang=js&"
export * from "./GiftPurchaseImportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports